<template>
  <div class="login-page">

    <!-- MAIN -->
    <div class="mss-login-outer">
      <div class="mss-login-left d-flex align-items-center py-5 py-lg-0 mss-left-panel">
          <div class="w-100" style="max-width:420px;margin:auto">

            <div class="text-center mb-4">
              <router-link to="/">
                <img src="@/assets/images/mss/logo.png" alt="MSS" height="100" style="cursor: pointer;" />
              </router-link>
            </div>

            <h1 class="font-weight-bold mb-3 mss-login-title">
              Plateforme de commande en ligne
            </h1>
            <p class="text-muted mb-4">
              Accès sécurisé à votre catalogue, vos commandes, BLs et factures.
            </p>

            <form v-if="!forgetPasswordisClicked && !createNewAccountClicked"
                  @submit.prevent="tryToLogIn">

              <div class="form-group">
                <label>Nom d’utilisateur ou email</label>
                <div class="input-icon">
                  <i class="fa fa-user"></i>
                  <input
                    v-model="email"
                    type="email"
                    class="form-control"
                    placeholder="ex : example@email.com"
                    tabindex="1"
                  />
                </div>
              </div>

              <div class="form-group">
                <div class="d-flex justify-content-between">
                  <label>Mot de passe</label>
                  <a href="#" class="small text-primary" @click="openForgetPassword">Mot de passe oublié ?</a>
                </div>
                <div class="input-icon">
                  <i class="fa fa-lock"></i>
                  <input
                    v-model="password"
                    type="password"
                    class="form-control"
                    placeholder="Votre mot de passe"
                    tabindex="2"
                  />
                </div>
              </div>

              <button class="btn btn-primary btn-block py-2 font-weight-bold">
                Se connecter
              </button>

              <p class="text-center mt-4" style="font-size: 15px;">
                <span class="font-weight-bold" @click="openCreateNewAccount()" style="cursor: pointer; color: #1853ba;">
                  Demandez votre accès professionnel
                </span>
              </p>

              <b-alert
                v-if="isAuthError"
                variant="danger"
                show
                class="fancy-alert mt-3"
              >
                <div class="d-flex align-items-center">
                  <i class="fa fa-exclamation-circle mr-2 alert-icon"></i>
                  <div>
                    <strong>Erreur de connexion</strong><br />
                    <span class="alert-text">{{ errorMessage }}</span>
                  </div>
                </div>
              </b-alert>

            </form>

            <div v-if="forgetPasswordisClicked">

              <h4 class="mb-3">Mot de passe oublié</h4>

              <input v-model="username" class="form-control mb-2" placeholder="Email" />
              <input v-model="newPassword" class="form-control mb-2" placeholder="Nouveau mot de passe" />
              <input v-model="confPassword" class="form-control mb-3" placeholder="Confirmation" />

              <button class="btn btn-primary btn-block" @click="createCode">
                Envoyer le code
              </button>

              <input v-model="code" class="form-control mt-3" placeholder="Code reçu" />

              <button class="btn btn-success btn-block mt-2" @click="resetPassword">
                Réinitialiser
              </button>

              <div class="text-center mt-3">
                <a href="#" @click.prevent="forgetPasswordisClicked=false">
                  Retour à la connexion
                </a>
              </div>
            </div>

            <div v-if="createNewAccountClicked">

              <h4 class="mb-3">Demande de compte professionnel</h4>

              <input
                v-model="newAccountCompanyName"
                class="form-control mb-3"
                placeholder="Nom de la société"
              />

              <input
                v-model="newAccountCompanyPhone"
                class="form-control mb-3"
                placeholder="Téléphone ou email"
              />

              <button class="btn btn-primary btn-block" @click="addAccountRequest">
                Envoyer la demande
              </button>

              <p class="text-center text-muted small mt-4">
                Déjà un compte ?
                <a href="#" class="text-primary font-weight-bold" @click.prevent="createNewAccountClicked=false">
                  Se connecter
                </a>
              </p>
            </div>

            <div class="border-top pt-3 mt-4 text-center">
              <router-link to="/" class="small text-muted">
                <i class="fa fa-arrow-left mr-1"></i>Retour à l'accueil
              </router-link>
            </div>

          </div>
        </div>

        <!-- RIGHT : Graphical background -->
        <div class="mss-login-right position-relative mss-auth-panel">

          <!-- Same graphical layers as hero -->
          <div class="mss-auth-grid"></div>
          <div class="mss-auth-ring mss-auth-ring--1"></div>
          <div class="mss-auth-ring mss-auth-ring--2"></div>
          <div class="mss-auth-glow"></div>

          <!-- Floating pharma + IT icons -->
          <div class="mss-auth-float mss-af-1"><i class="fas fa-pump-soap"></i></div>
          <div class="mss-auth-float mss-af-2"><i class="fas fa-microchip"></i></div>
          <div class="mss-auth-float mss-af-3"><i class="fas fa-stethoscope"></i></div>
          <div class="mss-auth-float mss-af-4"><i class="fas fa-atom"></i></div>
          <div class="mss-auth-float mss-af-5"><i class="fas fa-database"></i></div>
          <div class="mss-auth-float mss-af-6"><i class="fas fa-heartbeat"></i></div>
          <div class="mss-auth-float mss-af-7"><i class="fas fa-thermometer-half"></i></div>
          <div class="mss-auth-float mss-af-8"><i class="fas fa-shield-alt"></i></div>
          <div class="mss-auth-float mss-af-9"><i class="fas fa-laptop-medical"></i></div>
          <div class="mss-auth-float mss-af-10"><i class="fas fa-syringe"></i></div>

          <!-- Centered branding -->
          <div class="mss-auth-center">
            <img src="@/assets/images/mss/logo.png" alt="MSS" class="mss-auth-logo" />
            <h2 class="mss-auth-title">Médical Santé Service</h2>
            <div class="mss-auth-accent"></div>
            <p class="mss-auth-sub">Grossiste répartiteur en parapharmacie</p>
            <p class="mss-auth-desc">
              Votre partenaire de référence pour les pharmacies,<br>
              cliniques et professionnels de santé.
            </p>
          </div>

        </div>

    </div>
  </div>
</template>



<script>
import { authMethods } from "@/state/helpers";
import AuthApi from "@/services/auth-api";
import UsersApi from "@/services/users-api";
import Vue from "vue";

export default {
  name: "Login",

  data() {
    return {
      email: "",
      password: "",
      authError: null,
      isAuthError: false,
      tryingToLogIn: false,

      forgetPasswordisClicked: false,
      createNewAccountClicked: false,

      username: "",
      newPassword: "",
      confPassword: "",
      code: "",

      errorMessage: "",
      secondErrorMessage: "",
      showErrorMesage: false,
      showSecondErrorMessage: false,

      newAccountCompanyName: "",
      newAccountCompanyPhone: ""
    };
  },

  methods: {
    ...authMethods,

    /* 🔐 LOGIN */
    tryToLogIn() {
      this.tryingToLogIn = true;
      this.isAuthError = false;

      this.logIn({
        email: this.email,
        password: this.password
      })
        .then(() => {
          this.$router.push({ name: "default" });
        })
        .catch(error => {
          this.authError = error;
          this.isAuthError = true;
          Vue.prototype.$snotify.error(error);
        })
        .finally(() => {
          this.tryingToLogIn = false;
        });
    },

    /* 🔁 FORGET PASSWORD */
    openForgetPassword() {
      this.forgetPasswordisClicked = true;
      this.createNewAccountClicked = false;
    },

    createCode() {
      return AuthApi.createCode(this.username, this.newPassword, this.confPassword)
        .catch(err => {
          this.errorMessage = err;
          this.showErrorMesage = true;
        });
    },

    resetPassword() {
      return AuthApi.resetPassword(this.username, this.code)
        .catch(err => {
          this.secondErrorMessage = err;
          this.showSecondErrorMessage = true;
        });
    },

    /* 🏢 PRO ACCOUNT */
    openCreateNewAccount() {
      this.createNewAccountClicked = true;
      this.forgetPasswordisClicked = false;
    },

    addAccountRequest() {
      UsersApi.addAccountRequest(
        this.newAccountCompanyName,
        this.newAccountCompanyPhone
      ).then(() => {
        Vue.prototype.$snotify.success("Demande envoyée avec succès");
        this.createNewAccountClicked = false;
      });
    }
  }
};
</script>


<style scoped>
.login-page {
  background: #fff;
}

/* Outer flex row: left panel | right panel */
.mss-login-outer {
  display: flex;
  min-height: 100vh;
}

/* Left panel: 50% on desktop, full width on mobile */
.mss-login-left {
  flex: 0 0 50%;
  max-width: 50%;
  padding: 60px 40px;
}

/* Right panel: 50% on desktop, hidden on mobile */
.mss-login-right {
  flex: 0 0 50%;
  max-width: 50%;
  display: flex;
}

@media (max-width: 991px) {
  .mss-login-left {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 40px 24px;
  }
  .mss-login-right {
    display: none;
  }
}

.mss-login-title {
  font-size: 1.9rem;
  color: #1853ba;
  white-space: nowrap;
}
@media (max-width: 480px) {
  .mss-login-title {
    font-size: 1.35rem;
    white-space: normal;
  }
}

.mss-left-panel {
  background:
    radial-gradient(ellipse at 0% 0%, rgba(24, 83, 186, 0.28) 0%, transparent 50%),
    radial-gradient(ellipse at 100% 100%, rgba(24, 83, 186, 0.22) 0%, transparent 48%),
    radial-gradient(ellipse at 50% 100%, rgba(138, 199, 39, 0.10) 0%, transparent 45%),
    #ffffff;
}


.input-icon {
  position: relative;
}
.input-icon i {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  color: #1853ba;
  font-size: 15px;
}
.input-icon input {
  padding-left: 42px;
}

.login-page .form-control {
  height: 50px;
  font-size: 15px;
  border: 1.5px solid #d0d9e8;
  border-radius: 10px;
  background: #f8fafd;
  color: #1a2340;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.login-page .form-control:focus {
  border-color: #1853ba;
  box-shadow: 0 0 0 3px rgba(24, 83, 186, 0.10);
  background: #fff;
}
.login-page label {
  font-size: 13px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 6px;
}
.login-page .btn-primary {
  height: 50px;
  font-size: 16px;
  border-radius: 10px;
  background: #1853ba;
  border-color: #1853ba;
  letter-spacing: 0.3px;
}
.login-page .btn-primary:hover {
  background: #0c2472;
  border-color: #0c2472;
}

/* ── Right graphical panel ── */
.mss-auth-panel {
  background:
    radial-gradient(ellipse at 78% 18%, rgba(138, 199, 39, 0.14) 0%, transparent 52%),
    radial-gradient(ellipse at 12% 88%, rgba(24, 83, 186, 0.20) 0%, transparent 45%),
    linear-gradient(135deg, #04112e 0%, #0c2472 35%, #1853ba 65%, #0b2e8a 100%);
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* Tech grid */
.mss-auth-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px),
    radial-gradient(rgba(255,255,255,0.055) 1px, transparent 1px);
  background-size: 64px 64px, 64px 64px, 32px 32px;
  pointer-events: none;
}

/* Depth rings */
.mss-auth-ring {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.mss-auth-ring--1 {
  width: 480px; height: 480px;
  right: -100px; top: -120px;
  border: 1px solid rgba(255, 255, 255, 0.06);
}
.mss-auth-ring--2 {
  width: 280px; height: 280px;
  right: 30px; top: 40px;
  border: 1px solid rgba(138, 199, 39, 0.10);
  background: radial-gradient(circle, rgba(138,199,39,0.04) 0%, transparent 70%);
}

/* Green glow */
.mss-auth-glow {
  position: absolute;
  width: 360px; height: 360px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(138, 199, 39, 0.11) 0%, transparent 68%);
  right: -20px; top: -60px;
  pointer-events: none;
}

/* Floating icons */
.mss-auth-float {
  position: absolute;
  pointer-events: none;
  user-select: none;
  color: rgba(255, 255, 255, 0.07);
}
.mss-af-1  { font-size: 2.6rem; top: 8%;    right: 18%; color: rgba(138,199,39,0.10); }
.mss-af-2  { font-size: 2rem;   top: 48%;   right: 7%;  }
.mss-af-3  { font-size: 2.4rem; top: 16%;   right: 5%;  color: rgba(138,199,39,0.08); }
.mss-af-4  { font-size: 1.8rem; top: 68%;   right: 20%; }
.mss-af-5  { font-size: 1.6rem; top: 6%;    left: 6%;   }
.mss-af-6  { font-size: 2.2rem; bottom: 20%; left: 5%;  color: rgba(138,199,39,0.09); }
.mss-af-7  { font-size: 1.4rem; top: 36%;   left: 4%;   color: rgba(138,199,39,0.09); }
.mss-af-8  { font-size: 1.8rem; bottom: 12%; right: 10%; }
.mss-af-9  { font-size: 1.8rem; top: 62%;   left: 10%;  }
.mss-af-10 { font-size: 2rem;   bottom: 28%; right: 28%; color: rgba(138,199,39,0.07); }

/* Centered branding */
.mss-auth-center {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 40px;
}
.mss-auth-logo {
  height: 120px;
  filter: brightness(0) invert(1);
  opacity: 0.93;
  margin-bottom: 32px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.mss-auth-title {
  font-size: 3rem;
  font-weight: 900;
  color: #fff;
  margin-bottom: 0;
  text-shadow: 0 2px 20px rgba(0,0,0,0.28);
  letter-spacing: -0.5px;
}
.mss-auth-accent {
  width: 70px;
  height: 5px;
  background: linear-gradient(to right, #8ac727, #b2e84a);
  border-radius: 3px;
  margin: 20px auto;
}
.mss-auth-sub {
  font-size: 15px;
  font-weight: 600;
  color: rgba(255,255,255,0.80);
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 20px;
}
.mss-auth-desc {
  font-size: 17px;
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.85;
  margin: 0;
}

.fancy-alert {
  border: 0;
  background: linear-gradient(135deg, #fff5f5, #ffe3e3);
  color: #842029;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(220, 53, 69, 0.15);
  animation: fadeSlide 0.35s ease-out;
}

.alert-icon {
  font-size: 26px;
  color: #dc3545;
}

.alert-text {
  font-size: 14px;
  opacity: 0.9;
}

@keyframes fadeSlide {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>
